import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import React, { useEffect, useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchCaseDetails } from '../../../../Api/Services/CaseApiServices'
import { AccountsIcon, StaffIcon } from '../../../../components/Icons/Icons';
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload';
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import CallButton from '../GlobalComponents/CallButton'

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, Role, setNaCTrigger }) => {
    const [userData, setUserData] = useState()
    const [parentCaseData, setParentCaseData] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [requesterData, setRequesterData] = useState();
    const [isOpen2, setIsOpen2] = useState(true);
    const [isOpen4, setIsOpen4] = useState(true);
    const [isOpen1, setIsOpen1] = useState(true);
    function findDataByEmail(CaseData) {
        if (CaseData?.requesterType === "Leads" || CaseData?.requesterType === "Contacts") {
            return {
                type: CaseData?.requesterType === "Leads" ? 'LEAD' : "CONTACT",
                name: CaseData?.caseCreater,
                email: CaseData?.caseCreaterEmail,
                cPermission: CaseData?.requesterPermission,
                id: CaseData?.caseCreaterId,
                profilePic: CaseData?.createrProfile,
            }
        }
        return {
            type: 'OTHER',
            name: CaseData?.caseCreater,
            email: CaseData?.caseCreaterEmail,
            cPermission: false,
            id: null,
            profilePic: null,
        };
    }
    function getRequesterData(CaseData) {
        if (CaseData?.requesterType === "Leads" || CaseData?.requesterType === "Contacts") {
            setRequesterData({
                type: CaseData?.requesterType === "Leads" ? 'LEAD' : "CONTACT",
                name: CaseData?.caseCreater,
                email: CaseData?.caseCreaterEmail,
                cPermission: CaseData?.requesterPermission,
                id: CaseData?.caseCreaterId,
                profilePic: CaseData?.createrProfile,
                account: CaseData?.accountName,
                accountId: CaseData?.accountId,
                aPermission: CaseData?.accountPermission,
                designation: CaseData?.desigination,
                phoneNumber: CaseData?.caseCreaterNumber && CaseData?.caseCreaterNumber !== "" ? CaseData?.caseCreaterNumber :
                    CaseData?.phone && CaseData?.phone !== "" ? CaseData?.phone :
                        CaseData?.mobile && CaseData?.mobile !== "" ? CaseData?.mobile : ""
            })
            return;
        }
        setRequesterData({
            type: 'OTHER',
            name: CaseData?.caseCreater,
            email: CaseData?.caseCreaterEmail,
            cPermission: false,
            id: null,
            profilePic: null,
            account: CaseData?.accountName,
            accountId: null,
            aPermission: false,
            designation: null,
            phoneNumber: CaseData?.caseCreaterNumber
        })
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getCaseData(params) {
        try {
            const Response = await FetchCaseDetails(params)
            const RequesterResponse = findDataByEmail(Response?.data)
            const DataSet = {
                ...Response?.data,
                AssigneeName: `${Response.data?.caseOwnerFirstName} ${Response.data?.caseOwnerLastName}`,
                AssigneeEmail: Response.data?.caseOwnerEmail,
                AssigneeProfile: Response.data?.caseOwnerProfilePic,
                AssigneeID: Response.data?.caseOwner,
                RequesterData: RequesterResponse,
                casePresent: Response?.allow ? "Yes" : "No",
                caseLinkType: Response?.CaseLinkType
            }
            setParentCaseData(DataSet)
        } catch (error) {
            message.error(error)
        }
    }
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand1 = (key) => {
        setIsOpen1(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.caseOwner) {
                getUsersData(displayData?.caseOwner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.caseOwner, isOpen4])
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.parentCase) {
                getCaseData(displayData?.parentCase)
            } else {
                setParentCaseData()
            }
        }
    }, [displayData?.parentCase, isOpen2])
    useEffect(() => {
        if (isOpen1) {
            if (displayData?.caseCreaterEmail && displayData?.caseCreaterEmail !== "") {
                getRequesterData(displayData)
            } else {
                setRequesterData()
            }
        }
    }, [displayData, isOpen1])
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand1} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Requester</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen1 ? "Close" : "View"}</Text></div>} key="1">
                    {requesterData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${requesterData?.cPermission && "ListNavigate"}`}
                            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                            tabIndex={0}
                            onClick={requesterData?.cPermission ? () => requesterData?.cPermission && ViewDetailPage(requesterData?.id, requesterData?.type) : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(requesterData?.id, requesterData?.type)
                                }
                            }}
                        >  {requesterData?.profilePic !== null && requesterData?.profilePic
                            !== undefined && requesterData?.profilePic !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={requesterData?.profilePic} alt="" />
                            </figure>
                            :
                            <span className={`list_span_Tag ${requesterData?.type === "LEAD" ? "LeadIcon" :
                                requesterData?.type === "CONTACT" ? "ContactIcon" : ""}`} style={{ flexShrink: 0, }}>
                                {requesterData?.name?.slice(0, 1).toUpperCase()}
                            </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={requesterData?.name}>{requesterData?.name}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={requesterData?.email}>{requesterData?.email}</div>
                            </figcaption>
                        </div>
                        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                            <StaffIcon height={15} width={15} marginRight={5} />{requesterData?.designation}
                        </div>
                        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                            <span className="call-Optionholder">{(requesterData?.phoneNumber === "0" || requesterData?.phoneNumber === 0) ? "" : <>
                                <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
                                <span>{requesterData?.phoneNumber}</span>
                                <CallButton number={requesterData?.phoneNumber} EntityData={{ type: "Case", data: requesterData, for: "Case", caseId: displayData?.caseId }} setNaCTrigger={setNaCTrigger} /> </>} </span>
                        </div>
                        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                            <AccountsIcon height={15} width={15} marginRight={5} /><span className={`user-info_image ${requesterData?.aPermission && "ListNavigate"}`}
                                role="button"
                                tabIndex={0}
                                onClick={requesterData?.aPermission ? () => requesterData?.aPermission && ViewDetailPage(requesterData?.accountId, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(requesterData?.accountId, "ACCOUNT")
                                    }
                                }}
                            >   <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={requesterData?.account}>{requesterData?.account}</div>
                                </figcaption></span>
                        </div>
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Assignee</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            {displayData?.parentCase ? <>
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Parent Incident</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                        {parentCaseData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${parentCaseData?.casePresent === "Yes" && "ListNavigate"}`}
                                role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                tabIndex={0}
                                onClick={parentCaseData?.casePresent === "Yes" ? () => ViewDetailPage(parentCaseData?.caseId, parentCaseData?.caseLinkType) : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(parentCaseData?.caseId, parentCaseData?.caseType);
                                    }
                                }}
                            >
                                <span className='list_span_Tag' style={{ flexShrink: 0, }}>
                                    {parentCaseData?.caseSubject?.slice(0, 1).toUpperCase()}
                                </span>
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={parentCaseData?.caseSubject}> {parentCaseData?.caseSubject}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={parentCaseData?.caseNumber}>{parentCaseData?.caseNumber}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(parentCaseData?.caseType && parentCaseData?.caseType !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Incident Type</Text> <br />
                                            <Text>{parentCaseData?.caseType}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(parentCaseData?.caseStatus && parentCaseData?.caseStatus !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Incident Status</Text> <br />
                                            <Text><div className={`status-text CaseStatus-${parentCaseData?.caseStatus === "On Hold" ? "OnHold" : parentCaseData?.caseStatus}`}>{parentCaseData?.caseStatus}</div></Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(parentCaseData?.caseOrigin && parentCaseData?.caseOrigin !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Incident Origin</Text> <br />
                                            <Text >{parentCaseData?.caseOrigin}</Text>
                                        </div> : <></>
                                    }
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(parentCaseData?.casePriority && parentCaseData?.casePriority !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Incident Priority</Text> <br />
                                            <Text >{parentCaseData?.casePriority}</Text>
                                        </div> : <></>
                                    }
                                </Col>
                            </Row>
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Requester</Text> <br />
                                <Text> <div className={`user-info_image ${parentCaseData?.RequesterData?.cPermission && "ListNavigate"}`}
                                    style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                    onClick={parentCaseData?.RequesterData?.type !== "OTHER" ? () => parentCaseData?.RequesterData?.cPermission && ViewDetailPage(parentCaseData?.RequesterData?.id, parentCaseData?.RequesterData?.type) : undefined}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            ViewDetailPage(parentCaseData?.RequesterData?.id, parentCaseData?.RequesterData?.type)
                                        }
                                    }}
                                >
                                    {parentCaseData?.RequesterData?.profilePic !== null && parentCaseData?.RequesterData?.profilePic
                                        !== undefined && parentCaseData?.RequesterData?.profilePic !== "" ?
                                        <figure>
                                            <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={parentCaseData?.RequesterData?.profilePic} alt="" />
                                        </figure>
                                        :
                                        <span className={`list_span_Tag ${parentCaseData?.RequesterData?.type === "LEAD" ? "LeadIcon" :
                                            parentCaseData?.RequesterData?.type === "CONTACT" ? "ContactIcon" : ""}`} style={{ flexShrink: 0, }}>
                                            {parentCaseData?.RequesterData?.name?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <figcaption style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden", // 👈 keeps ellipsis responsive
                                    }}>
                                        <div style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={parentCaseData?.RequesterData?.name}>{parentCaseData?.RequesterData?.name}</div>
                                        <div style={{
                                            fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={parentCaseData?.RequesterData?.email}>{parentCaseData?.RequesterData?.email}</div>
                                    </figcaption>
                                </div></Text>
                            </div>
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
                                <Text ><div className={`user-info_image ${(Role === "Administrator" || profile.userId === parentCaseData?.AssigneeID) && "ListNavigate"}`}
                                    role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                    tabIndex={0}
                                    onClick={(Role === "Administrator" || profile.userId === parentCaseData?.AssigneeID) ? () => parentCaseData?.AssigneeID && ViewDetailPage(parentCaseData?.AssigneeID, "USER") : undefined}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            ViewDetailPage(parentCaseData?.AssigneeID, "USER");
                                        }
                                    }}
                                >  {parentCaseData?.AssigneeProfile !== null && parentCaseData?.AssigneeProfile
                                    !== undefined && parentCaseData?.AssigneeProfile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={parentCaseData?.AssigneeProfile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                        {parentCaseData?.AssigneeName?.slice(0, 1).toUpperCase()}
                                    </span>
                                    }
                                    <figcaption style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden", // 👈 keeps ellipsis responsive
                                    }}>
                                        <div style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={parentCaseData?.AssigneeName}>{parentCaseData?.AssigneeName}</div>
                                        <div style={{
                                            fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={parentCaseData?.AssigneeEmail}>{parentCaseData?.AssigneeEmail}</div>
                                    </figcaption>
                                </div></Text>
                            </div>
                        </div>
                            : <div className='RightSide-DataShadow'>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "10rem"
                                }}>
                                    <Spin />
                                </div>
                            </div>}
                    </Panel>
                </Collapse >
                <Divider style={{ margin: "10px 0" }} /></> : ""}
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.uploadFile?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.uploadFile?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    Role: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
};
export default NoteDetails;
